module.exports = __webpack_public_path__ + "img/LTS_MZ.1eddc7aa.gif";